import { Component, inject, OnInit, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { ConfirmationModalComponent, DataTableComponent } from "../../../../shared/components";
import { genericFloatButtons } from "../../../../shared/components/general/float-action";
import { Constants } from "../../../../shared/constants/constants";
import { Language } from "../../../../shared/constants/enums";
import { TableButtonClicked } from "../../../../shared/models";
import { AppService } from "../../../../shared/services";
import { OnlineHelpService } from "../../../../shared/services/online-help-service";

@Component({
  selector: "adaa-faqs-list",
  imports: [DataTableComponent, TranslatePipe],
  templateUrl: "./faqs-list.html",
  styleUrl: "./faqs-list.scss",
})
export class FaqsListComponent implements OnInit {
  private _router = inject(Router);
  private _modalService = inject(NgbModal);
  private _appService = inject(AppService);
  private _onlineHelpService = inject(OnlineHelpService);
  private _toastrService = inject(ToastrService);
  private _translateService = inject(TranslateService);

  private readonly _genericFloatButtons = genericFloatButtons();
  adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");
  Constants = Constants;

  public ngOnInit(): void {
    this._floatActions();
  }

  public addNew() {
    this._router.navigateByUrl("console/help/faqs/create");
  }

  public getAction(value: TableButtonClicked) {
    switch (value.event) {
      case "edit":
        this._router.navigateByUrl(`console/help/faqs/edit/${value.data.id}`);
        break;
      case "delete":
        this._deleteFAQ(value.data.id);
        break;

      default:
        break;
    }
  }

  private _deleteFAQ(id: number) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });

    modal.componentInstance.header = "help.faqs.delete_yes_no_title";
    modal.componentInstance.title = "help.faqs.delete_yes_no_information";

    modal.result.then((e) => {
      if (e) {
        this._onlineHelpService.deleteFAQ(id).subscribe({
          next: (response) => {
            if (response.inError) return;
            this._toastrService.success(this._translateService.instant("notification.success.remove"));
            this.adaaDataTable().loadTableData();
          },
        });
      }
    });
  }

  private _floatActions(): void {
    this._genericFloatButtons([
      {
        key: "helpdesk",
        data: {
          url: "/helpdesk/create",
        },
      },
      {
        key: "print",
        data: undefined,
      },
    ]);
  }
}
